import { useState, useSyncExternalStore } from "react";
import type { EmulatorConfig } from "firebase/auth";
import { PlugIcon, XIcon } from "lucide-react";

import { Badge } from "components/ui/badge";
import { auth } from "integrations/firebase/auth";

// The SDK sets `emulatorConfig` once when the auth module connects and rejects
// a later connect, so there is no change to be notified about.
const subscribe = () => () => {};

const getEmulatorConfig = (): EmulatorConfig | null => auth.emulatorConfig;

export function EmulatorBadge() {
  const emulator = useSyncExternalStore(subscribe, getEmulatorConfig);
  const [isDismissed, setIsDismissed] = useState(false);

  if (!emulator || isDismissed) {
    return null;
  }

  return (
    <Badge
      variant="error"
      className="group fixed bottom-3 left-3 z-[100] gap-1.5 border-badge-error/20 py-1 text-sm shadow-list-item select-none [&>svg]:size-3.5"
    >
      <PlugIcon aria-hidden />
      Connected to Emulator
      <button
        type="button"
        aria-label="Dismiss emulator badge"
        onClick={() => setIsDismissed(true)}
        className="-ml-1.5 w-0 overflow-hidden opacity-0 transition-all duration-300 group-hover:ml-0 group-hover:w-4 group-hover:opacity-100 group-focus-within:ml-0 group-focus-within:w-4 group-focus-within:opacity-100"
      >
        <XIcon aria-hidden className="size-4" />
      </button>
    </Badge>
  );
}
